import type { SVGProps } from "react";
import { Settings } from "lucide-react";

export function SettingsIcon(props: SVGProps<SVGSVGElement>) {
  return <Settings color="currentColor" {...props} className={`w-5 h-5 ${props.className ?? ""}`} />;
}
